module.exports = __webpack_public_path__ + "img/9788971969632.c6933257.jpg";